import {FC} from 'react';
import {HourglassIllustrationIcon} from 'shared/assets/icons';
import {MY_TAX_CHECKING_TITLE, PARTNER_AGREEMENT_CHECKING_DESCRIPTION} from '../../model';
import {StepLayout} from 'features/registration';
import styles from './MyTaxCheckingStep.module.css';

export const PartnerAgreementCheckingStep: FC = () => {
	return (
		<StepLayout variant="fill" className={styles.root}>
			<StepLayout.Content className={styles.centered}>
				<HourglassIllustrationIcon className={styles.icon} aria-hidden />

				<div className={styles.text}>
					<StepLayout.Title>{MY_TAX_CHECKING_TITLE}</StepLayout.Title>
					<StepLayout.Subtitle muted>{PARTNER_AGREEMENT_CHECKING_DESCRIPTION}</StepLayout.Subtitle>
				</div>
			</StepLayout.Content>
		</StepLayout>
	);
};
